import { render } from "./ResetPassword.vue?vue&type=template&id=bbe9d566&scoped=true&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=bbe9d566&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe9d566"]])

export default __exports__